module.exports = __webpack_public_path__ + "img/license-CC0.64e3c782.png";